import React from 'react'
import LoadingPlaceholder from 'components/LoadingPlaceholder'

export default function withLoader(Component) {
  return function WithLoader(props) {
    return (
      <LoadingPlaceholder isLoading={props.isLoading}>
        <Component {...props} />
      </LoadingPlaceholder>
    )
  }
}
